import api from '@/api'

const state = {
  farms: []
}

const mutations = {
  SET_FARMS(state, farms) {
    state.farms = farms
  }
}

const actions = {
  async getFarms({ commit }) {
    try {
      const response = await api.get_farms()
      commit('SET_FARMS', response.data.list)
    } catch (error) {
      console.error('Failed to fetch farms:', error)
    }
  }
}

const getters = {
  farms: (state) => state.farms
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}